export const CONTACT_EMAIL = "info@parvatiistays.com";
export const CONTACT_PHONE_E164 = "+61420654411";
export const CONTACT_PHONE_DISPLAY = "+61 420654411";
